/* Kikaboni Build Your Stack quiz. No framework. Copy lives in kb-quiz-config.json, product data in the #kb-quiz-data JSON block. */
(function () {
  'use strict';
  var root = document.querySelector('[data-kb-quiz]');
  if (!root || root.dataset.kbInit) return;
  root.dataset.kbInit = '1';

  var STORE_KEY = 'kbQuiz.v1';
  var SCREENS = ['intro', 'age', 'primary', 'secondary', 'followup', 'experience', 'diets', 'safety', 'email', 'results', 'stop'];
  var Q_INDEX = { age: 1, primary: 2, secondary: 3, followup: 4, experience: 5, diets: 6, safety: 7 };

  var cfg = null;
  var data = { stacks: [] };
  var state = load() || fresh();

  var el = {
    intro: root.querySelector('[data-kb-screen="intro"]'),
    card: root.querySelector('[data-kb-card]'),
    progress: root.querySelector('[data-kb-progress]'),
    fill: root.querySelector('[data-kb-progress-fill]'),
    plabel: root.querySelector('[data-kb-progress-label]'),
    stage: root.querySelector('[data-kb-stage]'),
    start: root.querySelector('[data-kb-start]')
  };

  /* ---------- helpers ---------- */
  function fresh() {
    return { screen: 'intro', a: {}, session_id: uuid(), started: false, submitted: false, tier: null };
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
  function load() {
    try { var s = sessionStorage.getItem(STORE_KEY); return s ? JSON.parse(s) : null; } catch (e) { return null; }
  }
  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function tpl(s, map) {
    return String(s).replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; });
  }
  function track(name, detail) {
    var payload = Object.assign({ event: name, quiz_version: cfg && cfg.quiz_version }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('kbquiz:' + name, { detail: payload }));
  }
  function goalByCode(code) {
    for (var i = 0; i < cfg.goals.length; i++) if (cfg.goals[i].code === code) return cfg.goals[i];
    return null;
  }
  function utm() {
    var p = new URLSearchParams(location.search);
    return { utm_source: p.get('utm_source') || '', utm_medium: p.get('utm_medium') || '', utm_campaign: p.get('utm_campaign') || '' };
  }
  function toast(msg) {
    var t = document.querySelector('.kb-toast');
    if (!t) { t = document.createElement('div'); t.className = 'kb-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }

  /* ---------- rendering ---------- */
  function go(screen) {
    state.screen = screen; save(); render();
  }
  function render() {
    var s = state.screen;
    if (s === 'intro') {
      el.intro.hidden = false; el.card.hidden = true; return;
    }
    el.intro.hidden = true; el.card.hidden = false;
    var q = Q_INDEX[s];
    if (q) {
      el.progress.hidden = false;
      el.fill.style.transform = 'scaleX(' + ((q - 1) / cfg.total_questions).toFixed(3) + ')';
      el.plabel.textContent = tpl(cfg.copy.progress_label, { n: q, total: cfg.total_questions });
    } else {
      el.progress.hidden = true;
    }
    var html = ({
      age: viewAge, primary: viewPrimary, secondary: viewSecondary, followup: viewFollowup,
      experience: viewExperience, diets: viewDiets, safety: viewSafety, email: viewEmail,
      results: viewResults, stop: viewStop
    })[s]();
    el.stage.innerHTML = '<div class="kb-quiz__screen" data-screen="' + s + '">' + html + '</div>';
    bind(s);
    var focus = el.stage.querySelector('h2, h1');
    if (focus) { focus.setAttribute('tabindex', '-1'); focus.focus({ preventScroll: true }); }
    var top = el.card.getBoundingClientRect().top + window.scrollY - 90;
    if (window.scrollY > top || s !== 'age') window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function radios(name, options, selected, cols) {
    var out = '<div class="kb-quiz__options' + (cols === 2 ? ' kb-quiz__options--2' : '') + '">';
    options.forEach(function (o, i) {
      var id = 'kb-' + name + '-' + i;
      out += '<label class="kb-opt" for="' + id + '"><input type="radio" id="' + id + '" name="' + name + '" value="' + esc(o.key) + '"' + (selected === o.key ? ' checked' : '') + '>' +
        '<span class="kb-opt__box"><span class="kb-opt__mark" aria-hidden="true"></span><span class="kb-opt__text">' + esc(o.label) + (o.sub ? '<span class="kb-opt__sub">' + esc(o.sub) + '</span>' : '') + '</span></span></label>';
    });
    return out + '</div>';
  }
  function checks(name, options, selected) {
    var out = '<div class="kb-quiz__options kb-quiz__options--2">';
    options.forEach(function (o, i) {
      var id = 'kb-' + name + '-' + i;
      out += '<label class="kb-opt kb-opt--check" for="' + id + '"><input type="checkbox" id="' + id + '" name="' + name + '" value="' + esc(o.key) + '"' + (o.exclusive ? ' data-exclusive' : '') + (selected.indexOf(o.key) > -1 ? ' checked' : '') + '>' +
        '<span class="kb-opt__box"><span class="kb-opt__mark" aria-hidden="true"></span><span class="kb-opt__text">' + esc(o.label) + '</span></span></label>';
    });
    return out + '</div>';
  }
  function question(text, help) {
    return '<h2 class="kb-quiz__q" id="kb-q-title">' + esc(text) + '</h2>' + (help ? '<p class="kb-quiz__help">' + esc(help) + '</p>' : '');
  }
  function nav(showBack, nextLabel, extra) {
    return '<div class="kb-quiz__nav">' + (showBack ? '<button type="button" class="kb-btn kb-btn--ghost" data-kb-back>' + esc(cfg.copy.back) + '</button>' : '') + (extra || '') +
      '<button type="submit" class="kb-btn kb-btn--primary" data-kb-next>' + esc(nextLabel || cfg.copy.next) + '</button></div>';
  }
  function form(inner) { return '<form novalidate data-kb-form>' + inner + '</form>'; }

  function viewAge() {
    var sc = cfg.screens.age;
    return form(question(sc.question) + '<fieldset><legend class="visually-hidden">' + esc(sc.question) + '</legend>' + radios('age', sc.options, state.a.age, 2) + '</fieldset>' + nav(false));
  }
  function viewPrimary() {
    var sc = cfg.screens.primary;
    return form(question(sc.question, sc.help) + '<fieldset><legend class="visually-hidden">' + esc(sc.question) + '</legend>' + radios('primary', cfg.goals.map(function (g) { return { key: g.code, label: g.label }; }), state.a.primary, 2) + '</fieldset>' + nav(true));
  }
  function viewSecondary() {
    var sc = cfg.screens.secondary;
    var opts = cfg.goals.filter(function (g) { return g.code !== state.a.primary; }).map(function (g) { return { key: g.code, label: g.label }; });
    return form(question(sc.question, sc.help) + '<fieldset><legend class="visually-hidden">' + esc(sc.question) + '</legend>' + radios('secondary', opts, state.a.secondary, 2) + '</fieldset>' +
      nav(true, null, '<button type="button" class="kb-btn kb-btn--link" data-kb-skip>' + esc(sc.skip) + '</button>'));
  }
  function viewFollowup() {
    var fu = cfg.followups[state.a.primary];
    return form(question(fu.question) + '<fieldset><legend class="visually-hidden">' + esc(fu.question) + '</legend>' + radios('focus', fu.options, state.a.focus, 2) + '</fieldset>' + nav(true));
  }
  function viewExperience() {
    var sc = cfg.screens.experience;
    return form(question(sc.question) + '<fieldset><legend class="visually-hidden">' + esc(sc.question) + '</legend>' + radios('experience', sc.options, state.a.experience) + '</fieldset>' + nav(true));
  }
  function viewDiets() {
    var sc = cfg.screens.diets;
    return form(question(sc.question, sc.help) + '<fieldset><legend class="visually-hidden">' + esc(sc.question) + '</legend>' + checks('diets', sc.options, state.a.diets || []) + '</fieldset>' + nav(true));
  }
  function viewSafety() {
    var sc = cfg.screens.safety;
    return form(question(sc.question, sc.help) + '<fieldset><legend class="visually-hidden">' + esc(sc.question) + '</legend>' + checks('safety', sc.options, state.a.safety || []) + '</fieldset>' + nav(true, cfg.copy.next));
  }
  function viewEmail() {
    var c = cfg.copy.email; var v = state.a.contact || {};
    return form(question(c.headline, c.text) +
      '<div class="kb-quiz__row">' +
      '<label class="kb-field"><span class="kb-field__label">' + esc(c.first_name) + '</span><input type="text" name="first_name" autocomplete="given-name" required maxlength="60" value="' + esc(v.first_name) + '"></label>' +
      '<label class="kb-field"><span class="kb-field__label">' + esc(c.email) + '</span><input type="email" name="email" autocomplete="email" required inputmode="email" value="' + esc(v.email) + '"></label>' +
      '</div>' +
      '<label class="kb-field"><span class="kb-field__label">' + esc(c.phone) + '</span><input type="tel" name="phone" autocomplete="tel" inputmode="tel" value="' + esc(v.phone) + '"></label>' +
      '<label class="kb-field kb-field--hp" aria-hidden="true" tabindex="-1"><span>Website</span><input type="text" name="website" tabindex="-1" autocomplete="off"></label>' +
      '<fieldset><legend class="visually-hidden">Text messages</legend><label class="kb-opt kb-opt--check" for="kb-sms"><input type="checkbox" id="kb-sms" name="sms_consent" value="1"' + (v.sms_consent ? ' checked' : '') + '><span class="kb-opt__box"><span class="kb-opt__mark" aria-hidden="true"></span><span class="kb-opt__text"><span class="kb-opt__sub">' + esc(c.sms_label) + '</span></span></span></label></fieldset>' +
      '<p class="kb-consent">' + esc(c.consent) + '</p>' +
      '<p class="kb-error" role="alert" data-kb-error></p>' +
      nav(true, c.button));
  }
  function viewStop() {
    var s = cfg.stop;
    return '<h2 class="kb-quiz__q">' + esc(s.headline) + '</h2><p class="kb-quiz__help">' + esc(s.text) + '</p><div class="kb-quiz__nav"><a class="kb-btn kb-btn--primary" href="' + esc(root.dataset.rootUrl || '/') + '">' + esc(s.button) + '</a></div>';
  }

  /* ---------- results logic ---------- */
  function evaluate() {
    // The rules live in kb-stack-engine.js, shared with Kaia so both give the same answer
    if (!window.KbStackEngine) { console.error('[kb-quiz] kb-stack-engine.js did not load'); return null; }
    return window.KbStackEngine.evaluate(data.stacks, state.a);
  }

  function productCard(p, canBuy) {
    var held = p.held;
    var name = '<span class="kb-prod__name"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a>' + (p.core ? '<span class="kb-badge">' + esc(cfg.copy.results.core_badge) + '</span>' : '') + '</span>';
    var foot;
    if (held) {
      foot = '<span class="kb-prod__held"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>' + esc(cfg.copy.hold_label) + '</span>';
    } else if (canBuy) {
      foot = '<button type="button" class="kb-btn kb-btn--primary kb-prod__add" data-kb-add="' + p.variant_id + '">' + esc(cfg.copy.results.add) + '</button>';
    } else { foot = ''; }
    return '<li class="kb-prod' + (held ? ' kb-prod--held' : '') + '">' +
      '<img class="kb-prod__img" src="' + esc(p.image) + '" alt="" width="96" height="96" loading="lazy">' +
      '<div class="kb-prod__body">' + name + (p.role ? '<p class="kb-prod__role">' + esc(p.role) + '</p>' : '') + (p.caution && !held ? '<p class="kb-prod__caution">' + esc(cfg.copy.caution_line) + '</p>' : '') + '</div>' +
      '<div class="kb-prod__foot"><span class="kb-prod__price">' + esc(p.price_formatted) + '</span>' + foot + '</div></li>';
  }

  function viewResults() {
    var r = evaluate();
    var R = cfg.copy.results;
    if (!r) return '<h2 class="kb-quiz__q">' + esc(R.eyebrow) + '</h2><p class="kb-quiz__help">' + esc(R.unavailable) + '</p><div class="kb-quiz__nav"><button type="button" class="kb-btn kb-btn--ghost" data-kb-retake>' + esc(R.retake) + '</button></div>';
    var tier = state.tier || r.defaultTier;
    var list = tier === 'starter' ? r.starter : r.full;
    var canBuy = !r.providerFirst;
    var why = (cfg.stacks[r.stack.code] || {}).why || '';
    var who = state.a.contact && state.a.contact.first_name ? tpl(R.eyebrow_named, { name: state.a.contact.first_name }) : R.eyebrow;
    var h = '<p class="kb-res__eyebrow">' + esc(who) + '</p><h2 class="kb-res__title">' + esc(r.stack.title) + '</h2>';
    if (r.stack.social) h += '<p class="kb-res__social">' + esc(r.stack.social) + '</p>';
    if (why) h += '<p class="kb-res__why">' + esc(why) + '</p>';
    if (r.providerNotice) h += notice(cfg.copy.provider_notice, false);
    if (r.providerFirst) h += notice(cfg.copy.provider_first, true);
    h += '<div class="kb-tiers" role="group" aria-label="Stack size">' +
      '<button type="button" class="kb-tier" data-kb-tier="starter" aria-pressed="' + (tier === 'starter') + '"><strong>' + esc(R.tier_starter) + '</strong><span>' + esc(R.tier_starter_sub) + '</span></button>' +
      '<button type="button" class="kb-tier" data-kb-tier="full" aria-pressed="' + (tier === 'full') + '"><strong>' + esc(R.tier_full) + '</strong><span>' + esc(R.tier_full_sub) + '</span></button></div>';
    h += '<ul class="kb-products">' + list.map(function (p) { return productCard(p, canBuy); }).join('') + '</ul>';
    var buyable = list.filter(function (p) { return !p.held; });
    if (canBuy && buyable.length) {
      var asStack = tier !== 'starter' && r.whole;
      if (asStack) h += '<p class="kb-res__stackprice"><strong>' + esc(r.stack.price_formatted) + '</strong> <s>' + esc(r.stack.separate_formatted) + '</s> <span>' + esc(R.stack_price_note || 'Stack price, less than buying each formula separately') + '</span></p>';
      h += '<div class="kb-res__addall"><button type="button" class="kb-btn kb-btn--primary kb-btn--lg kb-btn--block" data-kb-add-all' + (asStack ? ' data-kb-add-stack="' + r.stack.variant_id + '"' : '') + '>' + esc(tpl(R.add_all, { tier: tier === 'starter' ? R.tier_starter + ' stack' : R.tier_full })) + '</button></div>';
    }
    // Hidden until the Kaia widget is on the page (see bind)
    h += '<div class="kb-res__kaia" data-kb-kaia hidden><p class="kb-res__kaia-text">' + esc(R.ask_kaia_text || 'Questions before you start? Kaia already has your quiz answers.') + '</p>' +
      '<button type="button" class="kb-btn kb-btn--ghost" data-kb-ask-kaia>' + esc(R.ask_kaia || 'Ask Kaia about your stack') + '</button></div>';
    if (r.secondary) {
      h += '<div class="kb-also"><div><p class="kb-also__label">' + esc(R.also) + '</p><h3 class="kb-also__title">' + esc(r.secondary.title) + (r.secondary.social ? ' <span class="kb-res__social" style="display:inline">(' + esc(r.secondary.social) + ')</span>' : '') + '</h3><p class="kb-also__text">' + esc(R.also_text) + '</p></div><a class="kb-btn kb-btn--ghost" href="' + esc(r.secondary.url) + '">' + esc(R.view_stack) + '</a></div>';
    }
    h += '<p class="kb-legal">' + esc(cfg.copy.legal_footer) + '</p>';
    h += '<div class="kb-res__foot"><button type="button" class="kb-btn kb-btn--link" data-kb-retake>' + esc(R.retake) + '</button></div>';
    return h;
  }
  function notice(text, info) {
    return '<div class="kb-notice' + (info ? ' kb-notice--info' : '') + '" role="note"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5m0 3h.01"/></svg><p>' + esc(text) + '</p></div>';
  }

  /* ---------- bindings ---------- */
  function bind(s) {
    var f = el.stage.querySelector('[data-kb-form]');
    var back = el.stage.querySelector('[data-kb-back]');
    if (back) back.addEventListener('click', function () { go(prev(s)); });
    var skip = el.stage.querySelector('[data-kb-skip]');
    if (skip) skip.addEventListener('click', function () { state.a.secondary = ''; answered(3); go('followup'); });
    el.stage.querySelectorAll('[data-exclusive]').forEach(function (ex) {
      var group = el.stage.querySelectorAll('input[name="' + ex.name + '"]');
      ex.addEventListener('change', function () { if (ex.checked) group.forEach(function (i) { if (i !== ex) i.checked = false; }); });
      group.forEach(function (i) { if (i !== ex) i.addEventListener('change', function () { if (i.checked) ex.checked = false; }); });
    });
    if (f) f.addEventListener('submit', function (e) { e.preventDefault(); submit(s, f); });
    el.stage.querySelectorAll('[data-kb-tier]').forEach(function (b) {
      b.addEventListener('click', function () { state.tier = b.dataset.kbTier; save(); render(); });
    });
    el.stage.querySelectorAll('[data-kb-add]').forEach(function (b) {
      b.addEventListener('click', function () { addToCart([b.dataset.kbAdd], b); });
    });
    var all = el.stage.querySelector('[data-kb-add-all]');
    if (all) all.addEventListener('click', function () {
      var ids = all.dataset.kbAddStack ? [all.dataset.kbAddStack] : [].map.call(el.stage.querySelectorAll('[data-kb-add]'), function (b) { return b.dataset.kbAdd; });
      addToCart(ids, all);
    });
    var kaiaBlock = el.stage.querySelector('[data-kb-kaia]');
    if (kaiaBlock) {
      // The widget loads separately and may arrive after the results render
      var showKaia = function () { if (window.Kaia) kaiaBlock.hidden = false; };
      showKaia();
      if (kaiaBlock.hidden) document.addEventListener('kaia:ready', showKaia, { once: true });
      kaiaBlock.querySelector('[data-kb-ask-kaia]').addEventListener('click', function () {
        if (!window.Kaia) return;
        track('kaia_handoff', { primary_stack: state.a.primary, tier: state.tier || (evaluate() || {}).defaultTier });
        window.Kaia.open({ message: cfg.copy.results.ask_kaia_message || 'I just finished the Build Your Stack quiz. Can you walk me through my results?' });
      });
    }
    var rt = el.stage.querySelector('[data-kb-retake]');
    if (rt) rt.addEventListener('click', function () { state = fresh(); save(); go('intro'); });
    if (s === 'results' && !state.resultsTracked) { state.resultsTracked = true; save(); track('results_viewed', { primary_stack: state.a.primary, tier: state.tier || (evaluate() || {}).defaultTier }); }
  }
  function prev(s) {
    var order = ['age', 'primary', 'secondary', 'followup', 'experience', 'diets', 'safety', 'email'];
    var i = order.indexOf(s); return i > 0 ? order[i - 1] : 'intro';
  }
  function answered(n) { track('question_answered', { screen: n }); }
  function picked(f, name) { var i = f.querySelector('input[name="' + name + '"]:checked'); return i ? i.value : ''; }
  function pickedAll(f, name) { return [].map.call(f.querySelectorAll('input[name="' + name + '"]:checked'), function (i) { return i.value; }); }
  function shake(f) { var first = f.querySelector('input'); if (first) first.focus(); toast(cfg.copy.error_pick); }

  function submit(s, f) {
    var v;
    if (s === 'age') { v = picked(f, 'age'); if (!v) return shake(f); state.a.age = v; answered(1); save(); return go(v === 'no' ? 'stop' : 'primary'); }
    if (s === 'primary') { v = picked(f, 'primary'); if (!v) return shake(f); if (state.a.primary !== v) { state.a.focus = ''; if (state.a.secondary === v) state.a.secondary = ''; } state.a.primary = v; answered(2); save(); return go('secondary'); }
    if (s === 'secondary') { state.a.secondary = picked(f, 'secondary'); answered(3); save(); return go('followup'); }
    if (s === 'followup') { v = picked(f, 'focus'); if (!v) return shake(f); state.a.focus = v; answered(4); save(); return go('experience'); }
    if (s === 'experience') { v = picked(f, 'experience'); if (!v) return shake(f); state.a.experience = v; state.tier = null; answered(5); save(); return go('diets'); }
    if (s === 'diets') { v = pickedAll(f, 'diets'); if (!v.length) return shake(f); state.a.diets = v.filter(function (x) { return x !== 'none'; }); answered(6); save(); return go('safety'); }
    if (s === 'safety') { v = pickedAll(f, 'safety'); if (!v.length) return shake(f); state.a.safety = v; answered(7); save(); return go('email'); }
    if (s === 'email') return submitEmail(f);
  }

  function submitEmail(f) {
    var err = f.querySelector('[data-kb-error]');
    var first = f.first_name.value.trim(); var email = f.email.value.trim();
    var ok = first.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    if (!ok) { err.textContent = cfg.copy.email.error_required; (first ? f.email : f.first_name).focus(); return; }
    err.textContent = '';
    if (f.website && f.website.value) { state.submitted = true; save(); return go('results'); } /* honeypot: discard silently */
    state.a.contact = { first_name: first, email: email, phone: f.phone.value.trim(), sms_consent: !!f.sms_consent.checked };
    var btn = f.querySelector('[data-kb-next]'); btn.disabled = true;
    var r = evaluate();
    var payload = Object.assign({
      first_name: first, email: email, phone: state.a.contact.phone, sms_consent: state.a.contact.sms_consent,
      consent_text_version: cfg.consent_text_version,
      primary_stack: state.a.primary, secondary_stack: state.a.secondary || '',
      focus: state.a.focus, experience: state.a.experience,
      default_tier: r ? r.defaultTier : (state.a.experience === 'active' ? 'full' : 'starter'),
      provider_notice: !!(r && r.providerNotice),
      quiz_version: cfg.quiz_version, session_id: state.session_id, submitted_at: new Date().toISOString()
    }, utm());
    track('email_submitted', { primary_stack: state.a.primary });
    webhook(payload).then(function () { state.submitted = true; save(); go('results'); });
  }

    // Section setting wins so the URL can change without a code edit
  var DEFAULT_WEBHOOK_URL = 'https://eojdz0g446csxc5.m.pipedream.net';

  function webhook(payload) {
    var url = (root.dataset.webhookUrl || '').trim() || DEFAULT_WEBHOOK_URL;
    var attempt = 0;
    function tryOnce() {
      attempt++;
      return fetch(url, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); })
        .catch(function (e) { if (attempt < 3) return new Promise(function (r) { setTimeout(r, 600 * attempt); }).then(tryOnce); console.warn('[kb-quiz] webhook failed', e); });
    }
    return tryOnce();
  }


  function addToCart(variantIds, btn) {
    var R = cfg.copy.results; var tier = state.tier || (evaluate() || {}).defaultTier;
    var items = variantIds.map(function (id) { return { id: parseInt(id, 10), quantity: 1, properties: { _quiz_stack: state.a.primary, _quiz_tier: tier } }; });
    var label = btn.textContent; btn.disabled = true; btn.textContent = R.adding;
    fetch(root.dataset.cartUrl + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Cart error'); }); return res.json(); })
      .then(function () {
        track('add_to_cart', { primary_stack: state.a.primary, tier: tier, count: items.length });
        btn.textContent = R.added; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function (e) { btn.disabled = false; btn.textContent = label; toast(e.message || 'Could not add to cart'); });
  }

  /* ---------- boot ---------- */
  function boot() {
    try { data = JSON.parse(root.querySelector('[data-kb-data]').textContent); data.stacks = (data.stacks || []).filter(function (s) { return s.code !== '__end__'; }); } catch (e) { console.warn('[kb-quiz] product data missing', e); }
    fetch(root.dataset.configUrl, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (c) {
      cfg = c;
      el.start.addEventListener('click', function () {
        if (!state.started) { state.started = true; track('quiz_start'); }
        go(state.screen === 'intro' ? 'age' : state.screen);
      });
      if (state.screen !== 'intro') { el.start.textContent = 'Continue where you left off'; render(); }
    }).catch(function (e) { console.error('[kb-quiz] config failed', e); el.start.disabled = true; });
  }
  boot();
})();
